import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../ui/accordion';

export const FAQ = () => {
  const faqs = [
    {
      question: 'O DRE+ é gratuito?',
      answer: 'Sim! Você pode começar a usar o DRE+ gratuitamente e sem cartão.',
    },
    {
      question: 'O DRE+ projeta o caixa para quantos dias?',
      answer: 'Até 360 dias, te ajudando a planejar seu caixa, definir metas e evitar surpresas.',
    },
    {
      question: 'Posso usar pelo celular?',
      answer: 'Com certeza! O DRE+ foi desenvolvido para funcionar perfeitamente em qualquer dispositivo - computador, tablet ou celular. Acesse suas finanças de qualquer lugar.',
    },
    {
      question: 'Meus dados estão seguros?',
      answer: 'A segurança dos seus dados é nossa prioridade. Utilizamos criptografia de ponta e backups automáticos para garantir que suas informações financeiras estejam sempre protegidas.',
    },
    {
      question: 'O que é o relatório DRE?',
      answer: 'O DRE (Demonstrativo de Resultado do Exercício) é um relatório contábil que mostra de forma clara se seu negócio está tendo lucro ou prejuízo, detalhando receitas, custos e despesas.',
    },
    {
      question: 'Preciso ter conhecimento contábil?',
      answer: 'Não! O DRE+ foi criado para ser simples e intuitivo. Você não precisa ser contador para usar. A interface é amigável e os relatórios são fáceis de entender.',
    },
    {
      question: 'Como faço para começar?',
      answer: 'É muito simples! Basta clicar no botão "Começar Agora" e criar sua conta. Em poucos minutos você já estará cadastrando suas contas a pagar e receber.',
    },
    {
      question: 'Posso exportar os relatórios?',
      answer: 'Sim! Você pode exportar todos os relatórios em formato PDF para compartilhar com seu contador, sócios ou para seus próprios arquivos.',
    },
    {
      question: 'O sistema emite notas fiscais?',
      answer: 'O DRE+ é focado no controle financeiro de contas a pagar e receber. Para emissão de notas fiscais, recomendamos utilizar um sistema específico de NF-e.',
    },
  ];

  return (
    <section id="faq" className="section-padding bg-[#F8FAFC]" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <span className="inline-block px-4 py-2 bg-[#D1FAE5] text-[#065F46] rounded-full text-sm font-semibold mb-4" data-testid="faq-badge">
            Dúvidas Frequentes
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F172A] mb-4" data-testid="faq-title">
            Perguntas <span className="text-[#047857]">Frequentes</span>
          </h2>
          <p className="text-lg text-[#64748B]" data-testid="faq-description">
            Tire suas dúvidas sobre o DRE+ Controle Financeiro
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          data-testid="faq-accordion"
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-white rounded-xl px-6 border border-slate-100 shadow-sm"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left font-heading font-semibold text-[#0F172A] hover:text-[#047857] py-5 text-lg">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#64748B] pb-5 text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
